import { PlusIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { Button } from "V2.0/common/button";
import RuleFormDialog from "./RuleFormDialog";
import RulesTable from "./RulesTable";
import { defaultRule } from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Models/Conditional";

export default Rules;

function Rules(props) {
  const { rules, onUpdateRule } = props;

  const [ruleFormDialog, setRuleFormDialog] = useState({
    mode: undefined,
    rule: undefined,
    ruleIdx: -1,
  });

  const handleAddRule = (rule) => {
    const updatedRules = [...rules, rule];
    onUpdateRule(updatedRules);
  };

  const handleRemoveRule = (ruleIdx) => {
    const updatedRules = rules.toSpliced(ruleIdx, 1);
    onUpdateRule(updatedRules);
  };

  const handleUpdateRule = (rule, ruleIdx) => {
    const updatedRules = rules.toSpliced(ruleIdx, 1, rule);
    onUpdateRule(updatedRules);
  };

  return (
    <>
      <div>
        <div className="flex justify-between items-center">
          <p>Rules</p>
          <Button
            color="white"
            onClick={() =>
              setRuleFormDialog({ mode: "add", rule: defaultRule, ruleIdx: -1 })
            }
          >
            <PlusIcon /> Rule
          </Button>
        </div>
        <div>
          <RulesTable
            rules={rules}
            onEditRule={(rule, ruleIdx) =>
              setRuleFormDialog({
                mode: "edit",
                rule,
                ruleIdx,
              })
            }
            onDeleteRule={(ruleIdx) => handleRemoveRule(ruleIdx)}
          />
        </div>
      </div>
      {ruleFormDialog.mode && (
        <RuleFormDialog
          mode={ruleFormDialog.mode}
          rule={ruleFormDialog.rule}
          ruleIdx={ruleFormDialog.ruleIdx}
          onAddRule={handleAddRule}
          onUpdateRule={handleUpdateRule}
          onClose={() =>
            setRuleFormDialog({ mode: undefined, rule: undefined, ruleIdx: -1 })
          }
        />
      )}
    </>
  );
}
